<template>
  <div class="list-subcontractors">
    <PageHeader title="Subcontractors" :action="{ title: 'Add new sub', to: { name: 'CreateSubcontractor' } }" />

    <BaseTable
      :items="subcontractors ?? []"
      :fields="fields"
      :is-loading="isPending"
      :error="error"
      :is-searchable="true"
      :clickable="true"
      :paginate="true"
      :next-page="nextPage"
      :prev-page="prevPage"
      :page="currentPage"
      :total-records="totalRecords"
      :total-pages="totalPages"
      :number-per-page="numPerPage"
      @on-search="(val) => search(val)"
      @row-selected="rowSelected"
    >
      <template #isCompany-data="data">
        <div class="ml-4 flex items-center justify-center w-10 h-10 rounded bg-slate-100 ring-1 ring-slate-300">
            <span v-if="data.row.isCompany" class="i-mdi-building size-6 text-accent"/>
            <span v-else class="i-mdi-construction-outline w-6 h-6 text-accent" />
          </div>
      </template>

      <template #name-data="data">
        <span class="font-semibold text-slate-950">{{ data.row.name }}</span>
      </template>

      <template #trade-data="data">
        {{ labors?.find(labor => labor.id === data.row.trade)?.name || data.row.trade }}
      </template>

      <template #contact-data="data">
        <div class="flex flex-col sm:flex-row gap-4">
          <span v-if="data.row.email" class="flex gap-2 items-center">
            <span class="i-mdi-email size-4 text-slate-500"></span>
            <span class="text-sm text-slate-500">{{ data.row.email }}</span>
          </span>
          <span v-if="data.row.phone" class="flex gap-2 items-center">
            <span class="i-mdi-phone size-4 text-slate-500"></span>
            <span class="text-sm text-slate-500">{{ data.row.phone }}</span>
          </span>
        </div>
      </template>
    </BaseTable>
  </div>
</template>

<script lang="ts" setup>
import PageHeader from '@/components/app/AppPageHeader.vue'
import { useHead } from '@unhead/vue'
import SubcontractorService from '@/services/SubcontractorService'
import BaseTable from '@/components/base/BaseTable.vue'
import { useRouter } from 'vue-router'
import { Subcontractor } from '@/models/subcontractor'
import { ref } from 'vue'
import useGetAllLabor from '@/composables/useGetAllLabor'
import { useSearchablePagination } from '@/composables/useSearchablePagination'

useHead({ title: 'Subcontractors' })

const fields = [
  { key: 'isCompany', label: 'Type', sortable: false },
  { key: 'name', label: 'Name', sortable: true },
  { key: 'trade', label: 'Trade', sortable: true },
  { key: 'contact', label: 'Contact' },
]

const subcontractorService = new SubcontractorService()
const numPerPage = ref(25)

const {
  results: subcontractors,
  isPending,
  error,
  search,
  currentPage,
  totalPages,
  totalRecords,
  nextPage,
  prevPage,
} = useSearchablePagination<Subcontractor>({
  indexName: 'subcontractors',
  service: subcontractorService,
  numPerPage: numPerPage.value,
  defaultOrderBy: 'name',
  defaultOrderDir: 'asc'
})

const { data: labors } = useGetAllLabor()

const $router = useRouter()
const rowSelected = (row: Subcontractor) => {
  $router.push({ name: 'ShowSubcontractor', params: { id: row.id } })
}
</script>
